{
  "name": "bp-web-components",
  "version": "0.22.0-alpha.7",
  "description": "Web components for The Bible Project Classroom visuals ",
  "license": "UNLICENSED",
  "type": "module",
  "main": "index.js",
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "build": "npm run clean && tsx scripts/build.ts",
    "clean": "rm -rf dist",
    "dev:serve": "tsx scripts/serve.ts",
    "dev:watch": "npm run build -- --watch",
    "dev": "run-p dev:*",
    "format": "prettier --write .",
    "lint": "eslint --cache --cache-location ./node_modules/.cache/eslint .",
    "prepare": "husky install",
    "storybook": "storybook dev -p 6006 --no-open",
    "storybook:build": "storybook build",
    "test": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc -b"
  },
  "dependencies": {
    "@lit-labs/observers": "^2.0.0",
    "classnames": "^2.3.2",
    "focus-trap": "^7.5.2",
    "hls.js": "^1.4.10",
    "idb": "^7.1.1",
    "lit": "^2.8.0"
  },
  "devDependencies": {
    "@babel/core": "^7.22.10",
    "@mswjs/http-middleware": "^0.8.0",
    "@storybook/addon-essentials": "^7.3.1",
    "@storybook/addon-interactions": "^7.4.2",
    "@storybook/addons": "^7.3.1",
    "@storybook/web-components": "^7.3.1",
    "@storybook/web-components-vite": "^7.3.1",
    "@testing-library/jest-dom": "^6.0.0",
    "@testing-library/user-event": "^14.4.3",
    "@types/cors": "^2.8.13",
    "@types/fs-extra": "^11.0.1",
    "@typescript-eslint/eslint-plugin": "^6.4.0",
    "@typescript-eslint/parser": "^6.4.0",
    "@vitest/coverage-v8": "^0.34.1",
    "chokidar": "^3.5.3",
    "chromatic": "^6.22.0",
    "cors": "^2.8.5",
    "cross-fetch": "^4.0.0",
    "esbuild": "^0.24.0",
    "eslint": "^8.47.0",
    "eslint-plugin-import": "^2.28.0",
    "eslint-plugin-storybook": "^0.6.13",
    "express": "^4.21.0",
    "fake-indexeddb": "^4.0.2",
    "fs-extra": "^11.1.1",
    "globby": "^13.2.2",
    "husky": "^8.0.3",
    "jsdom": "^22.1.0",
    "lint-staged": "^15.2.10",
    "msw": "^1.2.3",
    "msw-storybook-addon": "^1.8.0",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.0.2",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "storybook": "^7.3.1",
    "tsx": "^4.7.3",
    "typescript": "^5.1.6",
    "vite": "^4.5.5",
    "vite-tsconfig-paths": "^4.2.0",
    "vitest": "^0.34.1"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
